import Alert from '../../../itrust_common/components/Alert';
import { useDispatch } from 'react-redux';
import { scheduleJobLogCreate } from '../../../redux/actions/scheduleJobLogAction';
import { ImportButton } from '../../../itrust_common/components/others';

export default function ScheduleJobButton(props) {
  const { params, className, label, isImport, totalRecords, customScheduledFunc } = props
  const dispatch = useDispatch()

  const handleExportScheduleJob = () => {
    if (totalRecords > 5000) {
      Alert.confirm(<div>Your report will start generating during non working hours. Retrieve the report under Logs {'>'} Schedule Job Logs. Once the report has been successfully generated you will receive an email.</div>,
        (res) => {
          if (res) {
            if (customScheduledFunc) {
              customScheduledFunc()
            } else {
              dispatch(scheduleJobLogCreate(params))
            }
          }
        }
      )
    }
    else {
      Alert.confirm(<div>Your report will start generating now. Retrieve the report under Logs {'>'} Schedule Job Logs. Once the report has been successfully generated you will receive an email.</div>,
        (res) => {
          if (res) {

            if (customScheduledFunc) {
              customScheduledFunc()
            } else {
              // dispatch(paymentReportExport(params))
              dispatch(scheduleJobLogCreate(params))
            }
          }
        }
      )
    }
  }

  const handleImportScheduleJob = (data) => {
    dispatch(scheduleJobLogCreate(data))
  }

  return (
    <>
      {isImport ?
        <ImportButton
          {...props}
          isScheduleJobImport={true}
          onImportHook={(data) => handleImportScheduleJob(data)}
        /> :
        <button type="button" onClick={() => handleExportScheduleJob()} className={`btn ${className}`} >{label}</button>
      }
    </>
  )
}
